const mapImg = document.getElementById("map-img");
const mapCategories = document.querySelectorAll('.map-category');
const mapRegions = document.querySelectorAll('.region-item');

function retrieveCountry() {
    let country;

    if (localStorage.getItem("mapCountry")) {
        country = localStorage.getItem("mapCountry");
    } else {
        country = "cz";
    }

    activateCountry(country);
}

function displayMap() {
    const mapWrap = $("#home-map");
    let width = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;

    let type = "xs";

    if (width >= 768) {
        type = "lg";
    }

    $.ajax({
        url: "/parts/home-map/" + type,
        method: "post",
        data: {}
    }).done(function (result) {
        mapWrap.html(result);

        if (width >= 768) {
            $('#europe-map').JSMaps({
                map: 'europe',
                onStateClick: function (data) {
                    let url = data.url;
                    let itemId = "country-item-" + url.substring(1);
                    document.getElementById(itemId).click();
                },
                onStateOver: function (data) {
                    let url = data.url;
                    let item = "map-pin-country-" + url.substring(1);
                    let itemList = "country-item-" + url.substring(1);
                    let itemEl = document.getElementById(item);
                    if(itemEl) {
                        itemEl.classList.add("active");
                    }
                    let itemListEl = document.getElementById(itemList);
                    if (itemListEl) {
                        itemListEl.classList.add("active");
                    }
                },
                onStateOut: function (data) {
                    let url = data.url;
                    let item = "map-pin-country-" + url.substring(1);
                    let itemList = "country-item-" + url.substring(1);
                    let itemEl = document.getElementById(item);
                    if(itemEl) {
                        itemEl.classList.remove("active");
                    }
                    let itemListEl = document.getElementById(itemList);
                    if (itemListEl) {
                        itemListEl.classList.remove("active");
                    }
                },
            });

            $(".map-pin").hide();
            $(".map-pin-country").show();
        } else {
            retrieveCountry();
        }
    });
}

function activateCountry(country) {
    $(".map-category").removeClass("active");
    $("#map-category-" + country).addClass("active");

    $(".region-item").removeClass("active");

    $(".region-item[data-country=" + country + "]").addClass("active");

    $(".map-pin").hide();
    $("#map-pin-country-" + country).show();
}

function displayRegionsOfCountry(country) {
    $(".country-list").hide();

    $(".region-item").removeClass("active");
    $(".region-item[data-country=" + country + "]").addClass("active");

    $("#map-reset-to-eu").show();

    $(".map-pin").hide();
    $(".map-pin-parent-" + country).show();

    if (country === "cz" || country === "sk") {
        $("#europe-map").hide();
        let img = $("#map-img");
        let imgSrc = img.data(country);
        img.attr("src", imgSrc);

        $(".country-wrapper").show();
        $("#region-list-country-" + country).show();
    }
}

function displayCountries() {
    $(".region-item").removeClass("active");
    $(".region-list-country").hide();

    $(".country-list").show();
    $("#map-reset-to-eu").hide();

    $(".country-wrapper").hide();
    $("#europe-map").show();

    $(".map-pin").hide();
    $(".map-pin-country").show();
}


var resizeId;
window.addEventListener('resize', function () {
    clearTimeout(resizeId);
    resizeId = setTimeout(doneResizing, 200);
});

function doneResizing() {
    displayMap();
}

$(function () {
    displayMap();

    $(document).on("click", ".map-category", function () {
        let country = $(this).data("country");

        activateCountry(country);
    });

    $(document).on("click", ".country-item", function (e) {
        if ($(this).data("url") === "") {
            e.preventDefault();
            let country = $(this).data("country");

            displayRegionsOfCountry(country);
        }
    });

    $(document).on("mouseenter", ".country-item a", function (e) {
        let country = $(this).parent().data("country");
        $("#map-pin-country-" + country).addClass("active");
    });

    $(document).on("mouseout", ".country-item a", function (e) {
        let country = $(this).parent().data("country");
        $("#map-pin-country-" + country).removeClass("active");
    });


    $(document).on("mouseenter", ".region-item a", function (e) {
        let regionId = $(this).parent().data("id");
        $("#map-pin-region-" + regionId).addClass("active");
    });

    $(document).on("mouseout", ".region-item a", function (e) {
        let regionId = $(this).parent().data("id");
        $("#map-pin-region-" + regionId).removeClass("active");
    });

    $(document).on("mouseenter", ".map-pin-region", function () {
        let regionId = $(this).data("id");
        $("#region-item-" + regionId).addClass("hover");
    });

    $(document).on("mouseout", ".map-pin-region", function () {
        let regionId = $(this).data("id");

        $("#region-item-" + regionId).removeClass("hover");
    });

    $(document).on("click", "#map-reset-to-eu", function () {
        displayCountries()
    })
});


